export class CheckHelper {
  static hasErrorMessage = <T>(e: unknown): e is T =>
    !!e && typeof e === 'object' && 'message' in e && typeof e.message === 'string';
}
